import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from 'theSource/components';
import { Card } from 'theSource/features/IdCards/types';
import { getBase64ImageSrc } from 'theSource/utils';
import { IdCardFocused } from '../IdCardFocused';
import {
  IdCardHeaderStyled,
  IdCardStyled,
  IdCardTitleStyled,
  IdCardWrapperStyled,
  ImageStyled,
} from './IdCardStyled';
import { ROUTES } from 'theSource/app/routes';

export interface IdCardProps {
  card: Card;
}

export const IdCard = ({ card }: IdCardProps) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const { t } = useTranslation('pages.idCards');
  const navigate = useNavigate();
  const location = useLocation();

  const handleFocus = () => navigate(`#${card.id}`);
  const handleFocusOut = () => {
    setIsFlipped(false);
    navigate(ROUTES.main.idCards.path);
  };
  const handleFlip = () => setIsFlipped(!isFlipped);

  return (
    <IdCardWrapperStyled data-testid="id-card">
      <IdCardHeaderStyled>
        <IdCardTitleStyled variant="subtitle1">{card.name}</IdCardTitleStyled>
        <Button
          data-testid="flip-button"
          variant="tertiary"
          disabled={!card.backImage}
          label={t('flip')}
          onClick={handleFlip}
        />
      </IdCardHeaderStyled>
      <IdCardStyled onClick={handleFocus}>
        <ImageStyled
          src={getBase64ImageSrc(isFlipped ? card.backImage : card.frontImage)}
          alt={card.name}
        />
      </IdCardStyled>
      <IdCardFocused
        card={card}
        initialFlipped={isFlipped}
        isFocused={location.hash === `#${card.id}`}
        onFocusOut={handleFocusOut}
      />
    </IdCardWrapperStyled>
  );
};
